import Vue from 'vue'
import Vuex from 'vuex'
import {  filterRoutes } from '@/composables/index'
import { routes } from '@/router/index'
// console.log("🚀 ~ routes:", routes)
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    // 存储token
    token: localStorage.getItem('token') ? localStorage.getItem('token') : '',
    Authorization: localStorage.getItem('User') ? localStorage.getItem('User') : '',
    menu: [],
  },
  getters: {

  },
  mutations: {
    //注册处理函数，在login组件的login方法上使用this.$store.commit('login',data);
    login(state, user) {
      state.Authorization = user;
      localStorage.setItem('User', user)
    },
    setMenus(state, menu) {
      state.menu = menu
      localStorage.setItem('menu', menu)
    },
    loginToken(state,token){
      state.token = token;
      localStorage.setItem('token', token)
    }
  },
  actions: {
    filterRoute({commit,state}){
      return new Promise((resolve, reject)=>{
        let totalRoute = routes
        let rou =  filterRoutes(totalRoute, JSON.parse(state.menu))
        localStorage.setItem('userRoute', JSON.stringify(rou))
        resolve(rou)
      })
      
    }
  },
  modules: {

  }
})
